<nb-card class="spatial-container">
    <!-- Card header -->
    <nb-card-header>
        <div class="spatial-header">
            <div class="title">
                {{ title }}
            </div>
        </div>
        <div class="info-container">
            <div class="info-row d-flex align-items-center h-100" *ngFor="let info of headerData | async">
                <div class="info-box">
                    <p class="label">{{ info.label }}</p>
                    <p class="value mb-0">
                        {{ info.unit ? info.unit : "" }} {{ info.numerator }}{{ info.denominator }}
                    </p>
                </div>
            </div>
        </div>
    </nb-card-header>

    <!-- Body: map and map components -->
    <nb-card-body>
        <div #mapViewNode class="map-container" id="viewDiv">
            <ng-container *ngIf="metricSelectEnabled">
                <div class="map-controls-container">
                    <div>
                        <ngx-spatial-card-metric-select
                            *ngIf="cardResponse$ | async as cardResponse"
                            [options]="cardResponse.configData.metricGroups"
                            [initMetricKey]="cardResponse.sourceData.metricType"
                            (onSelectChange)="onUpdateMetric($event)"
                        ></ngx-spatial-card-metric-select>
                    </div>
                </div>

                <div *ngIf="legendBuckets$ | async as legendBuckets">
                    <ngx-spatial-card-category-filters
                        [categoryList]="legendBuckets"
                        [selectInLegend]="!!selectedCategories"
                        [form]="selectedCategoriesForm"
                    ></ngx-spatial-card-category-filters>
                </div>
            </ng-container>
        </div>
    </nb-card-body>
</nb-card>
